import type { FC } from "react";
import Chart, { type Props } from "react-apexcharts";

type PieChartProps = {
	options: Props;
	chartSeries: number[];
};

export const PieChart: FC<PieChartProps> = ({ options, chartSeries }) => {
	return <Chart options={options} series={chartSeries} type="donut" />;
};
